import { render, staticRenderFns } from "./registration_excel.html?vue&type=template&id=640ffd1d&scoped=true&external"
import script from "./registration_excel.vue?vue&type=script&lang=js"
export * from "./registration_excel.vue?vue&type=script&lang=js"
import style0 from "./registration_excel.vue?vue&type=style&index=0&id=640ffd1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ffd1d",
  null
  
)

export default component.exports